const { REACT_APP_API_HOST_REPLACE_PATTERN, REACT_APP_LAMBDA_HOST_REPLACEMENT } = process.env;

export const lambdaHostname = window.location.hostname.replace(
  new RegExp(REACT_APP_API_HOST_REPLACE_PATTERN),
  REACT_APP_LAMBDA_HOST_REPLACEMENT,
);
